import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class MemberService {
  private api = inject(ApiService);

  getOne(id: number) { return this.api.get(`/member/${id}`); }
  upsert(json: any) { return this.api.post('/member', json); }
  remove(id: number) { return this.api.get(`/member/remove/${id}`); }
  getPayment(id: number) { return this.api.get(`/member/${id}/payment`); }
  createBtPostValues(json: any) { return this.api.post('/member/bt_post_values', json); }
  createPayment(id: number, json: any) { return this.api.post(`/member/${id}/payment`, json); }
  getTransaction(id: number) { return this.api.get(`/member/${id}/transaction`); }
  getOneTransaction(id: number, transactionId: number) {
    return this.api.get(`/member/${id}/transaction/${transactionId}`);
  }
  upsertTransaction(id: number, json: any) { return this.api.post(`/member/${id}/transaction`, json); }
  getAddress(zip: string) { return this.api.get(`/member/zipcode/${zip}`); }
  updatePictureRotate(json: any) { return this.api.post('/member/picture/rotate', json); }
  exists(columnName: string, value: any) { return this.api.post('/member/exists', { name: columnName, value }); }
  createTempMemberPassword(json: any) { return this.api.post('/member/temp/pass', json); }
  createHistory(json: any) { return this.api.post('/member/history', json); }
  enable(json: any) { return this.api.post('/member/enable', json); }
  removePicture(json: any) { return this.api.post('/member/picture/remove', json); }
  disableHistory(json: any) { return this.api.post('/member/history/disable', json); }
  getCounsel(memberId: number) { return this.api.get(`/member/${memberId}/counsel`); }
  getPersonal(memberId: number) { return this.api.get(`/member/${memberId}/personal`); }
  getNotification(id: number | 'self' = 'self') { return this.api.get(`/member/${id}/notification`); }

  async uploadPicture(id: number, pictureId: number, fileData: FormData): Promise<any> {
    return this.api.post(`/member/${id}/picture/${pictureId}`, fileData);
  }
}
